exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shopping-basket[data-v-1e4d5584] {\n  position: relative;\n}\n.shopping-basket[data-basketsize][data-v-1e4d5584]:after {\n  content: attr(data-basketsize);\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background-color: #23b32f;\n  color: #fff;\n  position: absolute;\n  bottom: 100%;\n  left: 100%;\n  font-weight: 300;\n  line-height: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 10px;\n  padding-bottom: 1px;\n  transform: translateX(-8px) translateY(10px);\n}", ""]);

// exports
